import { ContactMethodBuilder } from '../contact-method/contact-method.builder';
var HelpcenterContactSettingsBuilder = /** @class */ (function () {
    function HelpcenterContactSettingsBuilder() {
        this.helpcenterContactSettings = {
            contactButtonEnabled: true,
            contactFromArticlePageEnabled: true,
            contactMethod: new ContactMethodBuilder().build()
        };
    }
    HelpcenterContactSettingsBuilder.prototype.withContactButtonEnabled = function (value) {
        this.helpcenterContactSettings.contactButtonEnabled = value;
        return this;
    };
    HelpcenterContactSettingsBuilder.prototype.withcontactFromArticlePageEnabled = function (value) {
        this.helpcenterContactSettings.contactFromArticlePageEnabled = value;
        return this;
    };
    HelpcenterContactSettingsBuilder.prototype.withMethod = function (value) {
        this.helpcenterContactSettings.contactMethod = value;
        return this;
    };
    HelpcenterContactSettingsBuilder.prototype.build = function () {
        return this.helpcenterContactSettings;
    };
    return HelpcenterContactSettingsBuilder;
}());
export { HelpcenterContactSettingsBuilder };
//# sourceMappingURL=helpcenter-contact-settings.builder.js.map